import React from 'react';
import classNames from 'classnames';
import propTypes from 'prop-types';

import { getMessage } from 'util/locale';

const OverlaySelectLayerGroups = ({
  extendedHeight,
  groups,
  selectedGroup,
  onSelect
}) => {
  const classString = classNames({
    'form-control': true,
    'vra-layer-selector__select': true,
    'vra-layer-selector__select--extended': extendedHeight,
    'vra-layer-selector__select--layerGroups': true
  });

  const groupList = [];
  groups.forEach( (group) => {
    const entryClassString = classNames({
      'vra-layer-selector__option': true,
      'vra-layer-selector__option--layerGroups': true,
      'vra-layer-selector__option--selected': (selectedGroup && group.type === selectedGroup.type),
      'vra-layer-selector__option--with-preview': false
    });
    groupList.push(
      <div
        className={entryClassString}
        key={`layerGroups-${group.type}`}
        onClick={ () => onSelect(group) }>
        <section className='vra-layer-selector__option-title'>
          <header data-test-id="map-group-selector">{getMessage(`label-text__overlay--${group.type}`)}</header>
        </section>
      </div>
    );
  });
  return (
    <div className={classString}>
      {groupList}
    </div>
  );
};

OverlaySelectLayerGroups.propTypes = {
  extendedHeight: propTypes.bool,
  groups: propTypes.arrayOf(propTypes.object).isRequired, // each element describes a group, with a layers array that has the layer types for that group
  onSelect: propTypes.func.isRequired,
  selectedGroup: propTypes.object // If undefined, no group is selected.
};

export default OverlaySelectLayerGroups;
